module.exports = __webpack_public_path__ + "img/package.c41b4066.svg";